import { Exclude, Expose } from "class-transformer";
import { observable } from "mobx";

export default class EtsDeclarationFormData {
  @observable
  year?: string;

  @observable
  @Exclude()
  supplyPointIds?: number[];

  @observable.ref
  @Expose({ name: "supply_points" })
  supplyPoints?: { [key: string]: boolean };

  @observable
  @Expose({ name: "authorized_person" })
  authorizedPerson?: boolean;

  @observable
  @Expose({ name: "first_name" })
  firstName?: string;

  @observable
  @Expose({ name: "last_name" })
  lastName?: string;

  @observable
  position?: string;

  @observable
  farmer?: boolean;

  @observable
  forester?: boolean;

  @observable
  @Expose({ name: "low_consumption" })
  lowConsumption?: boolean;

  static ValidationRules = {
    supplyPointIds: { required: { translationCode: "validators.select_supply_point" } },
    year: { required: { translationCode: "validators.select_year" }, number: true },
    farmer: {
      equalIf: {
        condition: (entity: EtsDeclarationFormData) => !entity.forester,
        parameter: true,
        translationCode: "validators.at_least_one",
      },
    },
    forester: {
      equalIf: {
        condition: (entity: EtsDeclarationFormData) => !entity.farmer,
        parameter: true,
        translationCode: "validators.at_least_one",
      },
    },
    firstName: { required: true },
    lastName: { required: true },
    position: { required: true },
  };
}
